var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg116Moon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.804,285.907c-14.396-9.296-32.69-7.904-45.522,3.462c-15.131,13.404-69.471,57.174-133.411,57.623 c-9.603,0.071-19.043-0.873-28.061-2.796c-60.108-12.818-107.222-59.871-120.031-119.872c-1.875-8.787-2.808-17.958-2.771-27.253 c0.171-42.69,22.179-92.612,58.871-133.541c11.552-12.886,13.053-31.344,3.737-45.928c-9.303-14.56-26.656-20.945-43.174-15.887 C132.176,17.715,86.913,49.229,53.544,92.849C19.561,137.27,1.062,190.345,0.045,246.336 c-0.653,35.967,5.965,70.97,19.673,104.037c13.202,31.852,32.338,60.443,56.875,84.981c24.553,24.554,53.169,43.702,85.054,56.916 c31.615,13.101,64.995,19.733,99.301,19.732c1.611,0,3.23-0.014,4.845-0.044c43.636-0.791,85.037-12.076,123.055-33.542 c9.619-5.431,13.014-17.63,7.583-27.25s-17.632-13.014-27.25-7.582c-32.166,18.161-67.195,27.71-104.113,28.38 c-60.368,1.091-117.247-21.952-160.189-64.894c-42.905-42.906-65.933-99.732-64.838-160.006 c1.696-93.462,61.43-174.945,149.424-204.938c-22.435,26.32-64.178,84.698-64.459,154.787 c-0.048,12.151,1.181,24.183,3.652,35.762c7.866,36.851,26.278,70.562,53.246,97.489c26.951,26.91,60.688,45.291,97.564,53.155 c11.846,2.527,24.217,3.764,36.684,3.675c29.061-0.204,59.201-7.481,89.585-21.629c27.215-12.672,48.819-28.179,63.596-40.491 c-6.886,19.454-16.476,37.82-28.575,54.705c-6.434,8.979-4.37,21.473,4.609,27.907c8.977,6.432,21.473,4.371,27.907-4.609 c16.293-22.741,28.741-47.767,36.997-74.385C515.308,312.246,509.093,295.133,494.804,285.907z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg116Moon);
export default __webpack_public_path__ + "static/media/116-moon.3833fc7a3730a69cff63ec3adaeee5e1.svg";
export { ForwardRef as ReactComponent };